import { useEffect, useState } from "react";
import BomColumnMappingTemplate from "./column-mapping.template";
import { bomColumnKeySaveAPI, columnMappingAPI} from "../Home-Page/home-page.component.service";
import { useParams, useNavigate } from "react-router-dom";

const BomColumnMappingComponent = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [bomData, setBomData] = useState({
      loading: true,
      rows: [],
      tableColumns: [],
    });
      
    const onLoad = async () => {
      setBomData({ ...bomData, loading: true });
      const resp = await columnMappingAPI(id);
  
      // console.log({ bomData });
      if (resp.status) {
        const formattedRows = resp.data.bomData.map((row, i) => {
          return {
            i,
            row,
            string: row.toString(),
            name: row.toString(),
            value: i,
          };
        });
  
        console.log({ formattedRows });
  
        setBomData({
          ...bomData,
          loading: false,
          data: resp.data,
          rows: formattedRows,
          columns: resp.data.columns?.map((column) => {
            return {
              name: column,
              value: column,
            };
          }),
        });
      }
    };
    const handleChange = (name, value) => {
      let updatedBomData = {
        ...bomData,
        [name]: value,
        columnsUpdated: !value ? false : true,
      };
  
      if (name === "columnRow" && value) {
        console.log({
          value:
            updatedBomData.rows[value].name &&
            updatedBomData.rows[value].name.split(","),
          valueV: value,
        });
        updatedBomData = {
          ...updatedBomData,
          columnsUpdated: true,
          columns: updatedBomData.rows[value].name.split(",").map((item) => {
            return {
              name: item,
              value: item,
            };
          }),
        };
      }
  
      setBomData(updatedBomData);
    };
  
  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      uniqueId: id,
      partNumberKey: bomData.partNumberKey,
      qtyKey: bomData.qtyKey,
      rowIndex: bomData.columnRow,
    };
  
    const resp = await bomColumnKeySaveAPI(payload);
    console.log({ payload, resp });
  
    if (resp.status) {
      navigate("/bom-tool/" + id);
    }
    setLoading(false);
    };
  
  
  
    useEffect(() => {
      if (id) onLoad();
    }, [id]);
  
    const templateModal = {
      id,
      bomData,
      loading,
    };
  
    const templateEvents = {
      handleChange,
      handleSubmit,
    };
  
    return (
      <BomColumnMappingTemplate
        templateModal={templateModal}
        templateEvents={templateEvents}
      />
    );
  };
  
  export default BomColumnMappingComponent;